const state = () => ({
  contracts: []
});

const getters = {
  contracts: state => {
    return state.contracts;
  },
  signedContracts: state => {
    return state.contracts.filter(c => c.signedAt || c.signed_at);
  },
  unsignedContracts: state => {
    return state.contracts.filter(c => !c.signedAt && !c.signed_at);
  }
};

const actions = {
  async fetchContracts({ commit }, { id }) {
    const { data: dataLegacy } = await this.$http.get(`/contracts/info`, {
      params: { "client-id": id }
    });
    dataLegacy.forEach(c => {
      c.legacy = true;
    });
    const { data } = await this.$httpGerenari.get(`/contracts`, {
      params: { page: 1, items_per_page: 20 }
    });
    commit("setContracts", data.concat(dataLegacy));
  },
  async sign({ commit }, { id, code }) {
    const { data } = await this.$http.post(`/contracts/sign/${id}`, { code });
    commit("setSign", data.contract);
  },
  async openContract({}, id) {
    const { data } = await this.$http.get(`/contracts/pdf/${id}`, {
      responseType: "arraybuffer"
    });
    const file = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  },
  async askContractCode({}, { id, force }) {
    const { data } = await this.$http.post(`/contracts/code/${id}`, { force });
    return data;
  }
};

const mutations = {
  setContracts(state, data) {
    state.contracts = data;
  },
  setSign(state, data) {
    const contract = state.contracts.find(c => c.id === data.id);
    if (contract) {
      contract.signedAt = data.signedAt;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
